import * as Yup from 'yup';
import { FormattedMessage } from 'react-intl';
import { Formik, FormikProps } from 'formik';
import { PoolConfirmationModal, PoolFormikTextfield } from '@synergy/components-next';

interface DemandDeclineModalProps {
    open: boolean;
    onConfirm: (declineReason: string) => void;
    onCancel: () => void;
}

interface DemandDeclineModalFormValues {
    declineReason: string;
}

const validationSchema = Yup.object().shape({
    declineReason: Yup.string().required('app.error.required'),
});

export const DemandDeclineModal = ({ open, onCancel, onConfirm }: DemandDeclineModalProps) => {
    const handleSubmit = ({ declineReason }: DemandDeclineModalFormValues) => {
        onConfirm(declineReason);
    };

    const initialValues: DemandDeclineModalFormValues = {
        declineReason: '',
    };

    return (
        <Formik
            onSubmit={handleSubmit}
            initialValues={initialValues}
            enableReinitialize={true}
            validationSchema={validationSchema}
        >
            {(formikProps: FormikProps<DemandDeclineModalFormValues>) => {
                return (
                    <PoolConfirmationModal
                        open={open}
                        title={<FormattedMessage id="app.demands.detail.noDemandWarning" />}
                        action={<FormattedMessage id="app.demands.detail.submit.short" />}
                        onConfirm={formikProps.handleSubmit}
                        isSuccessDialog={true}
                        onCancel={() => {
                            formikProps.resetForm();
                            onCancel();
                        }}
                    >
                        <PoolFormikTextfield
                            name="declineReason"
                            label={<FormattedMessage id="app.label.declineReason" />}
                            multiline={true}
                            rows={5}
                            maxRows={50}
                            fullWidth={true}
                            required={true}
                        />
                    </PoolConfirmationModal>
                );
            }}
        </Formik>
    );
};
